module.exports = __webpack_public_path__ + "img/img_zhaopin.515a4228.jpg";